<template>
  <v-container fluid class="px-0">
    <v-card outlined class="mb-4" v-if="!loadDefault">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="4"> {{ $t('Filtras') }}</v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <form @keydown.enter.prevent="submit()">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="6">
              <el-text-field
                label="Pavadinimas (LT)"
                v-model="mainData['title_lt-search-like']"
                hide-details
                :maxlength="100"
              />
            </v-col>
            <v-col cols="12" md="6">
              <el-text-field
                label="Pavadinimas (EN)"
                v-model="mainData['title_en-search-like']"
                hide-details
                :maxlength="100"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <el-button
                class="mr-1"
                title="Ieškoti"
                :loading="loading"
                color="primary"
                icon="ieškoti"
                @click.native.stop="searchData()"
              />
              <el-button
                color="secondary"
                icon="išvalyti"
                title="Išvalyti"
                :loading="loading"
                @click.native="clearData()"
              />
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminCountriesSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    loadDefault: null,
    mainData: {},
    classifiers: [],
    extraData: {
      objektas: null,
      veiksmas: [],
      rusys: {},
    },
    enableVeiksmas: false,
  }),
  computed: {
    ...mapGetters(['searchParams']),
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.searchData()
  },
  methods: {
    searchData() {
      let searchData = {
        ...this.mainData,
        ...(this.loadDefault ? this.extraData : {}),
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {
        objektas: null,
        veiksmas: [],
        rusys: {},
      }
      this.searchData()
    },
    submit() {
      this.searchData()
    },
  },
}
</script>
